export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=7013908faa53d5eaec8bf0c5aa26a84c39b71b3bef&name=pushAdClickData!'